import useUser from 'hooks/useUser';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import guessDeviceType, { DeviceType } from 'shared/utils/guessDeviceType';
import LINKS from 'shared/links';

export function MyEverBrightQRRelay() {
  const navigate = useNavigate();
  const { userResult, selectedAgreement } = useUser();
  const deviceType = guessDeviceType();

  // android devices are more common than apple, so default to android unless
  // device type specifically comes up apple
  useEffect(() => {
    if (deviceType === DeviceType.MOBILE_APPLE) {
      window.location.href = LINKS.MOBILE_APP_STOREFRONTS.apple;
    } else {
      window.location.href = LINKS.MOBILE_APP_STOREFRONTS.google;
    }
  }, [userResult, selectedAgreement, deviceType, navigate]);

  return null;
}

export default MyEverBrightQRRelay;
